import {
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from "@chakra-ui/react";
import { MOONGATE_PRIVACY_URL, MOONGATE_TERMS_SALE_URL } from "@lib/misc";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

const _t = (key: string) => key;

const CheckoutAcknowledgement = ({
  onChange: onChange,
}: {
  onChange: (value: boolean) => void;
}) => {
  const {
    register,
    formState: { errors, isValid, isDirty },
    getValues,
    watch,
  } = useForm<{ agreement: boolean }>();

  useEffect(() => {
    const subscription = watch(async () => {
      onChange(getValues().agreement);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <div className="flex flex-row items-center p-2">
      <FormControl isInvalid={Boolean(errors.agreement)}>
        <FormLabel htmlFor={"agreement"} variant="custom"></FormLabel>
        <Checkbox
          isInvalid={isDirty && !isValid}
          borderColor={"neutral.200"}
          type={"checkbox"}
          {...register("agreement", {
            required: "This field is required",
          })}
          spacing={4}
        >
          <span className="dark:text-white">
            {_t("I accept the Moongate ")}
          </span>
          <a
            target="_blank"
            href={MOONGATE_TERMS_SALE_URL}
            rel="noopener noreferrer"
            className="underline text-primary-300 font-bold"
          >
            {_t("Terms of Sale")}
          </a>
          <span className="dark:text-white">{_t(" and ")}</span>
          <a
            target="_blank"
            href={MOONGATE_PRIVACY_URL}
            rel="noopener noreferrer"
            className="underline text-primary-300 font-bold"
          >
            {_t("Privacy Policy")}
          </a>
          {_t(" *")}
        </Checkbox>
        {errors.agreement && (
          <FormErrorMessage>
            <>{errors.agreement?.message}</>
          </FormErrorMessage>
        )}
      </FormControl>
    </div>
  );
};

export default CheckoutAcknowledgement;
